import URIS from 'constants/uris';
import http from 'services/http';

export function authenticate(params) {
  return http.post(URIS.AUTH, params);
}
